import {ChangeDetectionStrategy, Component, Input, ViewChild} from '@angular/core'
import {
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import {KeyValuePipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-authenticated-time-tracking-overview-edit-date-row-grid-inline-form-group',
  templateUrl: './grid-inline-form-group.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: GridInlineFormGroupComponent,
    multi: true
  }],
  imports: [
    KeyValuePipe,
    TranslatePipe,
    ReactiveFormsModule
  ],
  standalone: true
})
export class GridInlineFormGroupComponent implements ControlValueAccessor {
  @Input() public errorMessages!: Record<string, string>

  public requiredValidator = Validators.required

  @ViewChild(FormControlDirective, {static: true})
  public formControlDirective?: FormControlDirective;

  @Input({required: true})
  public formControl!: FormControl;

  public registerOnTouched(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  public registerOnChange(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  public writeValue(obj: () => void): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }
}
